import React from "react"
import ScrollBar from "react-perfect-scrollbar"
import { useSelector } from "react-redux"
import { Card, Col, Row, Table } from "reactstrap"

const material = [
  {
    title: "生地商社",
    key: "fabricCompanyName",
  },
  {
    title: "生地メーカ",
    key: "brand",
  },
  {
    title: "Art No.",
    key: "fabricNumber",
  },
  {
    title: "カラー",
    key: "color",
  },
  {
    title: "表地組成",
    key: "outerMaterialComposition",
  },
]

const detail = [
  {
    title: "モデル",
    key: "model",
  },
  {
    title: "プリーツ",
    key: "pleats1",
  },
  {
    title: "プリーツ",
    key: "pleats2",
  },
  {
    title: "フロント",
    key: "front",
  },
  {
    title: "脇ポケット",
    key: "sidePocket",
  },
  {
    title: "ピスポケット",
    key: "pissPocket1",
  },
  {
    title: "ピスポケット",
    key: "pissPocket2",
  },
  {
    title: "フラップ",
    key: "flap",
  },
  {
    title: "ベルト持出",
    key: "takeOutYourBelt",
  },
  {
    title: "外脇ステッチ",
    key: "outerSideStitch",
  },
  {
    title: "ベルトループ",
    key: "beltLoop",
  },
  {
    title: "アジャスター",
    key: "adjuster",
  },
  {
    title: "ベルト巾",
    key: "beltWidth",
  },
  {
    title: "裾口仕様",
    key: "hemSpecification",
  },
  {
    title: "ひざ裏",
    key: "backOfTheKnee",
  },
]

function Spesification(props) {
  const store = useSelector(state => state)
  const size = store.inspection.rtwOrderSize.data
  return (
    <Card body>
      <ScrollBar style={{ height: 585, position: "relative" }}>
        <Row>
          <Col md="12">
            <Table bordered striped>
              <tbody>
                <tr>
                  <td className="text-center" colSpan={2}>
                    MATERIAL
                  </td>
                </tr>
                {material.map((i, k) => (
                  <tr key={k}>
                    <td style={{ width: 200 }}>{i.title}</td>
                    <td>{size[i.key]}</td>
                  </tr>
                ))}
                <tr>
                  <td className="text-center" colSpan={2}>
                    DESIGN／DETAIL
                  </td>
                </tr>
                {detail.map((i, k) => (
                  <tr key={k}>
                    <td>{i.title}</td>
                    <td>{size[i.key]}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </ScrollBar>
    </Card>
  )
}

export default Spesification
